// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers. The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getSocialMediaPosts, SocialMediaModel } from "@synd/App/Services/socialMediaService";

type HandlerType = ApiHandler<{ pageSize: number }, SocialMediaModel[]>;

export const DispatchBeginLoadPosts: HandlerType = props => {
    props.dispatch({ type: "xSocialMedia/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const pageSize = props.parameter.pageSize;
        props.apiResult = await getSocialMediaPosts(pageSize);
    } catch (error: any) {
        props.dispatch({
            type: "xSocialMedia/FailLoad",
            data: { error: error?.message ?? "Unknown error" },
        });
        return error?.message;
    }
};

export const DispatchCompleteLoadPosts: HandlerType = props => {
    props.dispatch({
        type: "xSocialMedia/CompleteLoad",
        data: { posts: props.apiResult },
    });
};

export const chain = [DispatchBeginLoadPosts, RequestDataFromApi, DispatchCompleteLoadPosts];

const loadPosts = createHandlerChainRunner(chain, "xSocialMedia/LoadPosts");
export default loadPosts;
